import React, { useEffect, useState } from 'react'
import { useGetIdentity, NotificationProvider, useNavigation, useTable, useUpdate, CrudFilter } from '@pankod/refine-core'
import { AntdLayout, Typography, Avatar, Space, Icons, Button, Badge, notification, Menu, Dropdown, Divider, MenuProps } from '@pankod/refine-antd'
import { getAllNotifications, getNotifications } from 'gql/query'
import { INotification } from 'interfaces'
import 'styles/custom.css'
import { List, message } from 'antd'
import VirtualList from 'rc-virtual-list'
import { UserOutlined, DownOutlined, ToolOutlined } from '@ant-design/icons'
import { useUserContext } from 'context/user'
import { BASE_URL_PRODUCTION } from '../../../constants'
import { NovuProvider, PopoverNotificationCenter, NotificationBell, IMessage } from '@novu/notification-center'
import CustomNotifications from 'components/CustomNotifications'
import Permissions, { grantList } from 'permissions'
import { transformOldNotification } from 'helpers'
import { Q_GET_USERS_BY_ROLES } from 'gql/queries'
import { useQuery } from '@tanstack/react-query'
import { nhost } from 'utility'
import { updateUser } from 'users'
const { Text } = Typography

const { BellOutlined } = Icons
type ItemType = {
  key: string
  label: string
  icon: any
}
export const Header: React.FC = () => {
  const { data: user } = useGetIdentity()

  const [count, setCount] = useState(0)
  const [maxCount, setMaxCount] = useState(99)
  const [reload, setReload] = useState(false)
  const { push, replace } = useNavigation()
  const { mutate } = useUpdate<INotification>()
  const [notificationList, setNotificationList] = useState([] as any[])
  const [roleMenu, setRoleMenu] = useState<ItemType[]>([])
  const { userRole, changeUser, userName, changeUserName, getAllUsersByRoles } = useUserContext()
  const { tableQueryResult, setFilters, filters } = useTable<INotification>({
    resource: 'notifications',
    initialSorter: [
      {
        field: 'created_at',
        order: 'desc',
      },
    ],
    permanentFilter: [
      {
        field: 'is_read',
        operator: 'eq',
        value: false,
      },
      {
        field: 'recepient_user_role',
        operator: 'eq',
        value: userRole,
      },
      {
        field: 'recepient',
        operator: 'eq',
        value: user?.id,
      },
      {
        field: 'is_old',
        operator: 'eq',
        value: true,
      },
    ],
    initialPageSize: 1000,
    metaData: {
      fields: [
        'id',
        'title',
        'source_name',
        'created_at',
        'updated_at',
        'sender',
        'recepient_user_role',
        'redirect_id',
        'redirect_component',
        { recepient_details: ['displayName'] },
        { sender_details: ['displayName'] },
        'recepient',
        'is_open',
        'is_read',
        'description',
        'is_old',
      ],
    },
    liveMode: 'auto',
    // liveParams: { },
    onLiveEvent: event => {
      refreshNotification()
    },
    queryOptions: {
      enabled: !(
        userRole === 'systemsupport' ||
        userRole === 'user' ||
        user === undefined ||
        user === null ||
        userRole === undefined ||
        userRole === null
      ),
    },
  })
  const { isLoading } = useQuery(
    ['users'],
    async () => {
      const res: any = await nhost.graphql.request(Q_GET_USERS_BY_ROLES)
      return res?.data
    },
    {
      onSuccess(data) {
        console.log('users', data)
        getAllUsersByRoles(data?.users)
        // setSupportUsers(users)
      },
    }
  )
  // console.log(!(userRole === 'systemsupport'), 'check')
  useEffect(() => {
    changeUser(user?.defaultRole)
    changeUserName(user?.displayName)
  }, [user])
  const refreshNotification = () => {
    tableQueryResult.refetch()
    setReload(!reload)
  }

  useEffect(() => {
    setFilters([
      {
        field: 'recepient',
        operator: 'eq',
        value: user?.id,
      },
    ])
    // setLoading(false)
  }, [userRole])
  useEffect(() => {
    let arr: any[] = []
    let count = 0

    tableQueryResult?.data?.data?.map((item: any) => {
      if ((user?.defaultRole === 'admin' || item?.recepient === user?.id) && item.is_open === false) {
        count++
      }

      arr.push(item)
    })
    let transformArr: any = transformOldNotification(arr)
    setNotificationList(transformArr)
    setCount(count)
    //  seNotificationList(response.notifications)
  }, [tableQueryResult?.data?.data])
  const updateNotification = async (item: any) => {
    mutate({
      resource: 'notifications',
      id: item?.id,
      values: { is_open: true, is_read: true },
    })
    replace('/' + item?.source_name + '/' + item?.redirect_component + '/' + item?.redirect_id)
    // push(BASE_URL_PRODUCTION + '/' + item?.source_name + '/' + item?.redirect_component + '/' + item?.redirect_id)
  }
  const menu =
    notificationList?.length > 0 ? (
      <List style={{ width: '400px', paddingLeft: '20px', background: '#fff', boxShadow: 'rgba(149, 157, 165, 0.2) 0px 8px 24px' }}>
        <VirtualList
          data={notificationList}
          height={200}
          itemHeight={47}
          itemKey="id"

          // onScroll={onScroll}
        >
          {(item: any) => (
            <List.Item key={item.id}>
              <List.Item.Meta
                title={<a onClick={() => updateNotification(item)}>{`${item.title} - from ${item?.sender_details?.displayName}`}</a>}
                description={item.description}
              />
            </List.Item>
          )}
        </VirtualList>
      </List>
    ) : (
      <List style={{ width: '200px', paddingLeft: '20px', background: '#fff', boxShadow: 'rgba(149, 157, 165, 0.2) 0px 8px 24px' }}>
        <List.Item key={'no-data'}>
          <List.Item.Meta title={<Text type="warning">No Notifications</Text>} description={''} />
        </List.Item>
      </List>
    )
  const shouldRenderHeader = user && (userName || user.avatar)
  const handleMenuClick: MenuProps['onClick'] = async e => {
    if (e?.key && user?.id) {
      const updateDefaultRole = await updateUser(user?.id, e.key)
    }
    Permissions.setGrants(grantList)
    localStorage.setItem('current_user_role', e.key)
    changeUser(e.key)
  }
  const handleMenuSupportClick: MenuProps['onClick'] = e => {
    changeUser(e.key)
    localStorage.setItem('current_user_role', e.key)
  }
  useEffect(() => {
    let arr: ItemType[] = []
    if (user?.roles?.length > 0) {
      user?.roles?.map((item: any, i: any) => {
        if (item !== 'user' && item !== 'me')
          arr.push({
            label: item,
            key: item,
            icon: <UserOutlined />,
          })
      })
    }
    setRoleMenu(arr)
  }, [user])

  function getInitials(name: string) {
    const words = name.trim().split(' ')
    if (words.length === 1) {
      return words[0].charAt(0).toUpperCase()
    }
    return (words[0].charAt(0) + words[words.length - 1].charAt(0)).toUpperCase()
  }
  const initials = getInitials(userName || '')
  const userRoles = <Menu onClick={userRole === 'systemsupport' ? handleMenuSupportClick : handleMenuClick} items={roleMenu} />

  const menulist = (
    <Menu
      items={[
        {
          key: '1',
          label: (
            <h4 onClick={() => push('/updateprofilepage')}>
              <UserOutlined /> Profile{' '}
            </h4>
          ),
        },
        // {
        //   key: '2',
        //   label: (
        //     <h4>
        //       <ToolOutlined /> Settings
        //     </h4>
        //   ),
        // },
        {
          style: { display: userRole === 'admin' ? 'none' : 'flex' },
          key: '3',
          label: (
            <h4 style={{ display: userRole === 'admin' ? 'none' : 'flex' }}>
              <Dropdown overlay={userRoles}>
                {/* <a onClick={e => e.preventDefault()}> */}
                <Space
                  style={{ border: '1px solid transparent', boxShadow: '0 2px 0 rgb(0 0 0 / 2%)', display: userRole === 'admin' ? 'none' : 'flex' }}
                >
                  Switch
                  <UserOutlined />
                </Space>
                {/* </a> */}
              </Dropdown>
              {/* <Dropdown.Button overlay={userRoles} placement="bottom" icon={<UserOutlined />}>
                Switch
              </Dropdown.Button> */}
            </h4>
          ),
        },
      ]}
    />
  )

  return shouldRenderHeader ? (
    <AntdLayout.Header
      style={{
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        padding: '0px 24px',
        height: '70px',
        // backgroundColor: '#F8F8FB',
        // borderBottom: '1px solid #d0d7e1',
        backgroundColor: '#FFFFFF',
        boxShadow: '6px 19px 21px -62px rgba(0,0,0,0.1), 0px 4px 6px -4px rgba(0,0,0,0.1)',
      }}
    >
      {/* <Dropdown overlay={menu} placement="bottomLeft">
        <div style={{ margin: '0 20px' }}>
          <Badge count={count ?? 0} className={`site-badge-count-${maxCount}`} style={{ backgroundColor: '#6659FF' }}>
            <Button
              icon={<BellOutlined />}
              style={{ fontSize: 'larger', border: 'none', color: 'black', background: 'transparent', boxShadow: 'none' }}
            />
          </Badge>
        </div>
      </Dropdown> */}
      <NovuProvider
        backendUrl={'https://amsnotifications.centa.org/api'}
        socketUrl={'wss://amsnotifications.centa.org'}
        subscriberId={user?.id}
        applicationIdentifier={'PEXzB2mUwzNo'}
        initialFetchingStrategy={{ fetchNotifications: true, fetchUserPreferences: true }}
      >
        {/* <PopoverNotificationCenter colorScheme="light" onNotificationClick={onNotificationClick}>
          {({ unseenCount }) => (
            <div
              style={{
                alignItems: 'center',
                display: 'flex',
                width: '50px',
                height: '50px',
              }}
            >
              <NotificationBell unseenCount={unseenCount} />
            </div>
          )}
        </PopoverNotificationCenter> */}
        <CustomNotifications oldNotifications={notificationList} />
      </NovuProvider>
      {/* <div>
        <Avatar shape="square" icon={<UserOutlined />} />
       
        {userName && (
          <>
            <Typography.Text
              style={{
                width: 50,
                marginLeft: '5px',
              }}
              ellipsis={{ tooltip: userName }}
            >
              {userName}
            </Typography.Text>
          </>
        )}
       
      </div> */}

      {/* <Dropdown overlay={menulist}>
        <Space style={{ marginLeft: '5px' }}>
          <DownOutlined />
        </Space>
      </Dropdown> */}
      {/* {userRole} */}
      <Dropdown overlay={menulist}>
        <Space style={{ marginLeft: '5px', cursor: 'pointer' }}>
          {/* <DownOutlined /> */}
          {initials ? (
            <Avatar
              style={{
                backgroundImage: 'linear-gradient(310deg, #7928ca 0%, #6659ff 100%)',
                verticalAlign: 'middle',
                fontSize: '18px',
                fontWeight: 'bold',
              }}
              size="large"
            >
              {initials}
            </Avatar>
          ) : (
            <Avatar shape="circle" icon={<UserOutlined />} />
          )}
          <div
            style={{
              lineHeight: '20px',
              marginLeft: '3px',
            }}
          >
            {userName && <Typography.Text style={{ fontWeight: 'bold', fontSize: '16px' }}>{userName}</Typography.Text>}
            <br />
            <Typography.Text style={{ fontFamily: 'serif', fontSize: '13px', fontWeight: 'bold' }}>{userRole}</Typography.Text>
          </div>
        </Space>
      </Dropdown>
    </AntdLayout.Header>
  ) : null
}
